import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthStore, InstallationDetailsStore } from '@store';
import { Observable, of, zip } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { OwnershipType } from '../../../projects/client';
import { RoutingService } from './routing.service';

@Injectable()
export class PartnerAccessGuardService {
  constructor(
    private authStore: AuthStore,
    private routingService: RoutingService,
    private installationDetailsStore: InstallationDetailsStore
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAuth(state);
  }

  private checkAuth(state: RouterStateSnapshot): Observable<boolean> {
    return this.authStore.isAuthorized$.pipe(
      filter((isAuthorized) => isAuthorized),
      switchMap(() =>
        zip(
          this.authStore.isRsaUser(),
          this.installationDetailsStore.isAccessListDefined$.pipe(
            filter((isAccessListDefined) => isAccessListDefined)
          )
        )
      ),
      switchMap(([isRsaUser, _isAccessListDefined]) => {
        return this.installationDetailsStore.ownershipType$.pipe(
          switchMap((ownershipType) => {
            if (ownershipType === OwnershipType.ResidentialEndUser) {
              this.routingService.navigateToInstallationDashboardFromGuard(state);

              return of(false);
            } else if (isRsaUser) {
              return this.installationDetailsStore.isInstallationWithCommercialOwner$.pipe(
                tap((isInstallationWithCommercialOwner) => {
                  if (!isInstallationWithCommercialOwner) {
                    this.routingService.navigateToInstallationDashboardFromGuard(state);

                    return of(false);
                  }

                  return of(true);
                })
              );
            } else {
              return this.authStore.companySubscriptionPlan$.pipe(
                filter((plan) => !!plan),
                switchMap(() => this.installationDetailsStore.isPartnerAccessMenuVisible()),
                tap((isMenuVisible) => {
                  if (!isMenuVisible) {
                    this.routingService.dropChildPathFromUrl();

                    return of(false);
                  }

                  return of(true);
                })
              );
            }
          })
        );
      })
    );
  }
}
